import Marketplace from "./Marketplace";


export default function Promotion() {

  return (
    <Marketplace promotionOnly={true}/>
  )
}